var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6775 23.9978C23.4133 23.9978 24 23.4018 24 22.6755V1.32235C24 0.586675 23.404 0 22.6775 0H1.32247C0.596042 0 0 0.595988 0 1.32235V22.6755C0 23.4111 0.596042 23.9978 1.32247 23.9978H22.6775Z",
    fill: "#4868AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5587 24V14.7063H19.6786L20.1443 11.0838H16.5587V8.77438C16.5587 7.72209 16.8475 7.01435 18.3562 7.01435H20.2747V3.76435C19.9394 3.71779 18.8032 3.62467 17.4807 3.62467C14.7147 3.62467 12.8242 5.3102 12.8242 8.4112V11.0838H9.69495V14.7063H12.8242V24H16.5587Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6b0c0ce33b54b88d80f021b926c3fa5a.svg";
export { ForwardRef as ReactComponent };